import React, { useMemo } from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import ReactHtmlParser from 'react-html-parser';

import {
  StyledSection,
  HeroVideoContainer,
  HeroWrapper,
  HeroOverlay,
  HeroCloudImage,
  HotelRoomBlockHeroTextColumn,
  HeroTextPairing,
  BlogCenterTextPairing,
  StyledGetStartedButton,
  Divider,
  HeroButtonGetStarted,
  OnlyUsText,
} from './HotelRoomBlocksHeroSection.styles';
import { ValuePropsArg, ValuePropsSection } from '@components/ValuePropsSection';
import { useTranslation } from 'react-i18next';

export const HotelRoomBlocksHeroSection = () => {
  const { t } = useTranslation('hotelRoomBlocks');
  const heroData = t('heroSection');

  const valueProps: ValuePropsArg[] = useMemo(
    () =>
      t('valueProps').map((valueProp) => ({
        ...valueProp,
        icon: valueProp.icon as ValuePropsArg['icon'],
      })),
    [t]
  );

  return (
    <>
      <StyledSection as="section" id="HotelRoomBlocks_Hero">
        <HeroVideoContainer>
          <HeroWrapper>
            <HeroOverlay />
            <HeroCloudImage src="hotel-room-blocks/Hero-1.jpeg" isEagerLoading width="100%" height="100%" optimization="aggressive" />
          </HeroWrapper>
        </HeroVideoContainer>
        <HotelRoomBlockHeroTextColumn verticalAlign="center">
          <Columns.Column width={'full'}>
            <Flex flexDirection={'column'} alignItems={['left', 'left']}>
              <HeroTextPairing
                title={ReactHtmlParser(heroData.title)}
                titleVariant="hed72Hero"
                titleColor="mono7"
                titleTagName="h1"
                alignment={'left'}
              />

              <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[4, 6]}>
                <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
                <BlogCenterTextPairing
                  alignment="left"
                  title={heroData.bullet1}
                  titleVariant="sectionEyeBrow24"
                  titleColor="humana1Light"
                  marginLeft={[6, 6]}
                />
              </Flex>
              <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[4, 6]}>
                <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
                <BlogCenterTextPairing
                  alignment="left"
                  title={heroData.bullet2}
                  titleVariant="sectionEyeBrow24"
                  titleColor="humana1Light"
                  marginLeft={[6, 6]}
                />
              </Flex>
              <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[4, 6]}>
                <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
                <BlogCenterTextPairing
                  alignment="left"
                  title={heroData.bullet3}
                  titleVariant="sectionEyeBrow24"
                  titleColor="humana1Light"
                  marginLeft={[6, 6]}
                />
              </Flex>
              <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[7, 8]}>
                <OnlyUsText alignment="left" title={heroData.bullet4} titleVariant="sectionEyeBrow20" titleColor="humana1Light" />
              </Flex>
              <HeroButtonGetStarted style={{ textAlign: 'left' }}>
                <StyledGetStartedButton id="hotelRoomBlocksHeroGetStartedBtn" page={'hotel-room-blocks'} variant="secondary">
                  {heroData.buttonStarted}
                </StyledGetStartedButton>
              </HeroButtonGetStarted>
            </Flex>
          </Columns.Column>
        </HotelRoomBlockHeroTextColumn>
      </StyledSection>
      <ValuePropsSection values={valueProps} />
      <Divider />
    </>
  );
};
